import { render } from "./QueryTypeMaster.vue?vue&type=template&id=39218c3b&scoped=true"
import script from "./QueryTypeMaster.vue?vue&type=script&lang=js"
export * from "./QueryTypeMaster.vue?vue&type=script&lang=js"

import "./QueryTypeMaster.vue?vue&type=style&index=0&id=39218c3b&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39218c3b"]])

export default __exports__